import { AnimatePresence } from 'framer-motion';
import { useExperience, phaseIndex } from '@/store/experience';
import { GateScene } from './GateScene';
import { PasswordGate } from './PasswordGate';
import { SkyDiveSequence } from './SkyDiveSequence';

export function OpeningSequence() {
  const phase = useExperience((s) => s.phase);
  const i = phaseIndex(phase);
  const inGate = i >= phaseIndex('AIRPLANE') && i <= phaseIndex('JUMPING');
  return (
    <>
      <AnimatePresence>{inGate && <GateScene key="gate-scene" />}</AnimatePresence>
      <AnimatePresence>{phase === 'PASSWORD' && <PasswordGate key="gate" />}</AnimatePresence>
      <SkyDiveSequence />
    </>
  );
}
